<template>
   <div class="">
    <router-link  class="mr-3 btn btn-info" :to="{name: 'SalesDetails', query: {saleId: data.id, companyId: $route.query.companyId, discountPrice: data.discountPrice, customer: data.customer, ...$route.query}}">
      {{$t('text.clickButtons.viewDetails')}}
    </router-link>
     <router-link  class="mr-3 btn btn-warning"  :to="{name: 'CreateNonWetProductBranchSales', query: {saleId: data.id, companyId: $route.query.companyId, discountPrice: data.discountPrice, customer: data.customer, ...$route.query}}" v-if="data.sameDayDates">
         {{$t('text.actionButtons.edit')}}
    </router-link> 
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
  },
  methods: {
   
    
    deleteSale() {
        const deleteConfirm = window.confirm("Are you sure you want to delete this sale?");
        if(deleteConfirm){
            this.axios.delete(`${configObject.apiBaseUrl}/NonWetProductSales/DeleteSales/${this.data.id}`, configObject.authConfig())
                .then(() => {                
                    this.$toast.open({
                      message: "Successfully deleted sale",
                      type: 'success',
                      duration: 5000
                    });
                    this.$eventHub.$emit("renderNonWetProductSales")
                }).catch(error => {       
                  this.$toast.open({
                      message: error.response.data.message ,
                      type: 'error',
                      duration: 5000
                  });
            });
        }
    }
  },
};

</script>